// extracted by mini-css-extract-plugin
export default {"wrapper":"widget_wrapper__pj099","padding":"widget_padding__XXY9E","margin":"widget_margin__NBKqY"};